import $ from 'jquery'
import React from 'react'
import { render } from 'react-dom'
import { LatestUpdates } from './LatestUpdates'
import { fetchLatestPostmarkUpdates } from './api'

const debug = require('debug')('pm:apps/latest-updates')
debug('loaded')

function mountLatestUpdates() {
  debug('mounting')
  const root = document.querySelector('.js-latest-updates')

  if (!root) {
    return
  }

  if (root) {
    render(
      <LatestUpdates fetchLatestPostmarkUpdates={fetchLatestPostmarkUpdates} />,
      root
    )
  }
}

$(() => {
  mountLatestUpdates()
})
